// extracted by mini-css-extract-plugin
export default {"office365Auth":"office365Auth_office365Auth__oH+5j"};